import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import Tabs from '../Tabs';
import ChemTable from '../ChemTable';
import { withMyRecordDefaultRoute } from './withMyRecordDefaultRoute';
import { Trash } from 'react-bootstrap-icons';
import { encode } from 'html-entities';

class MyRecord extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			activeTab: props.params.activeTab || 'General_Info',
			person: {
				NewRequest: {
					REQ_ID: 0,
					CAL_UID: props.user.uid,
					FNAME: props.user.firstName,
					LNAME: props.user.lastName,
					DEPT_ID: 10, // College of Chemistry
					END_APPT: null
				},
				appointments: [],
			},
			access: {
				bixby: false,
				stores: false
			},
			defaults: {
				building: null,
				location: null,
				room: null
			},
			pendingRequests: [],
			personColumns: [],
			apptColumns: [],
			buildings: [],
			rooms: {},
			locations: [],
			editorsOpen: [],
			renderKey: 0
		}
	}

	componentDidMount() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/BuildingAccess/GetMyRecord',
			overlay: true,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, caluid: this.props.user.uid }
		}).done(function (data) {
			if (data.Success) {
				// prepare person record
				var person = data.Person;

				// if this is an existing person
				if (person.PeopleView) {						
					// compose created, modified fields
					person.PeopleView.CREATE_BY = self.composeChangeInfo(person.PeopleView.CREATE_BY, person.PeopleView.CREATE_DATE);
					person.PeopleView.MODIF_BY = self.composeChangeInfo(person.PeopleView.MODIF_BY, person.PeopleView.MODIF_DATE);
					
					// fix end date
					person.PeopleView.END_DATE = self.dateTimeToMVC(self.getDate(person.PeopleView.END_DATE));
				} else {
					// fix end date
					person.NewRequest.END_APPT = self.dateTimeToMVC(self.getDate(person.NewRequest.END_APPT));
				}

				// if there is a safety certificate
				if (person.SafetyTraining.length > 0) {
					// compose message for safety certificate
					person.SafetyTraining = "Certificate Uploaded " + self.dateToString(self.getDate(person.SafetyTraining[0].DATE_CREATED));
				} else {
					// remove empty array
					person.SafetyTraining = null;
				}
				
				// prepare appointments
				var i;
				var access = {
					bixby: false,
					stores: false
				};
				var defaults = {
					building: null,
					location: null,
					role: null,
					room: null
				};
				
				// for each access, note if it is storeroom/bixby
				for (i = 0; i < data.PeopleAccess.length; i++) {
					if (data.PeopleAccess[i].LOC_ACCESS_ID === 1) {
						access.stores = true;
					} else if (data.PeopleAccess[i].LOC_ACCESS_ID === 21) {
						access.bixby = true;
					}
				}
				
				// find defaults for location, building, room
				defaults.location = data.Locations.length > 0 ? data.Locations[0].LOC_ACCESS_ID : null;
				defaults.building = data.Buildings.length > 0 ? data.Buildings[0].BUILDING_ID : null;
				var buildingStateID = self.getBuildingStateID(defaults.building);
				var rooms = data.Rooms[buildingStateID];
				defaults.room = (rooms && rooms.length > 0) ? rooms[0].ROOM_ID : null;

				// for each appointment
				var appointments = [];
				var apptColumns = [];
				for (i = 0; i < data.Appointments.length; i++) {
					var apptView = data.Appointments[i].AppointmentView;
					
					// if PI name should be suffixed with type
					if (apptView.TYPE_ID > 4 && apptView.TYPE_ID < 9) {
						// add type to PI name
						apptView.PI_NAME += ' ' + apptView.PI_TYPE;
					}
					
					// if there is no end date
					if (!apptView.END_ROLE_DATE) {
						// use role ID for current role
						defaults.role = apptView.ROLE_ID;
					}
					
					// assign existing access
					apptView.EXISTING_STORES_ACCESS = access.stores;

					// compose CREATE_BY and MODIF_BY field
					apptView.CREATE_BY = self.composeChangeInfo(apptView.ROLE_CREATE_BY, apptView.ROLE_CREATE_DATE);
					apptView.MODIF_BY = self.composeChangeInfo(apptView.ROLE_MODIF_BY, apptView.ROLE_MODIF_DATE);
					
					// initialize keys, access
					apptView.Keys = [];
					apptView.Access = [];
					apptView.selectedLocation = defaults.location;
					apptView.selectedBuilding = defaults.building;
					apptView.selectedRoom = defaults.room;
					apptView.newAppointmentFlag = false;
					
					appointments.push(apptView);
					apptColumns.push(self.copyColumns(existingApptColumns));
				}
				
				person.appointments = appointments;
				
				self.mergeState({
					person: person,
					access: access,
					defaults: defaults,
					pendingRequests: data.PendingRequests || [],
					personColumns: self.generatePersonColumns(person),
					apptColumns: apptColumns,
					buildings: data.Buildings,
					rooms: data.Rooms,
					locations: data.Locations,
					renderKey: self.state.renderKey + 1
				});			
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});	
	}
	
	componentDidUpdate(prevProps) {
		var newActiveTab = this.props.params.activeTab || 'General_Info';
		
		// this is necessary so browser back/forward buttons will work across tabs
		if (newActiveTab !== this.state.activeTab) {
			this.mergeState({
				activeTab: newActiveTab,
				renderKey: this.state.renderKey + 1
			});
		}
	}

	canClickTabItem(tab) {
		// prevent user from leaving a tab if an editor is open
		if (this.state.editorsOpen.filter(x => rgxKeys.test(x)).length > 0) {
			this.showAlert('Editor Open', 'Please close the key editor before leaving the appointment tab.');
			return false;
		} else if (this.state.editorsOpen.filter(x => rgxAccess.test(x)).length > 0) {
			this.showAlert('Editor Open', 'Please close the access editor before leaving the appointment tab.');
			return false;
		}
		
		return true;
	}
	
	convertTabToURL(tab) {
		if (tab === 'General Info') tab = 'General_Info'
		else if (tab === 'Pending Requests') tab = 'Pending_Requests'
		else if (tab.startsWith('Appointment ')) tab = 'Appointment_' + tab.substring(12);
		return tab;
	}
	
	convertURLToTab(url) {
		if (url === 'General_Info') url = 'General Info';
		else if (url === 'Pending_Requests') url='Pending Requests';
		else if (url.startsWith('Appointment_')) url = 'Appointment ' + url.substring(12);
		return url;
	}

	onClickTabItem(tab) {
		if (tab === '+') {
			// add new appointment and navigate to it
			var newApptCopy = this.copyObject(newAppointment);
			newApptCopy.PERSON_ID = this.props.user.personID;
			newApptCopy.newAppointmentFlag = true;
			var person = this.copyPerson();
			newApptCopy.APPT_IDX = person.appointments.length;
			// copy access for new appointment
			newApptCopy.EXISTING_STORES_ACCESS = this.state.access.stores;
			newApptCopy.EXISTING_BIXBY_ACCESS = this.state.access.bixby;
			// copy defaults for new appointment
			newApptCopy.ROLE_ID = this.state.defaults.role;
			newApptCopy.selectedLocation = this.state.defaults.location;
			newApptCopy.selectedBuilding = this.state.defaults.building;
			newApptCopy.selectedRoom = this.state.defaults.room;
			// add new appointment to new appointments array
			person.appointments.push(newApptCopy);
			var apptColumns = this.generateApptColumns(person, this.state.pendingRequests);
			this.mergeState({
				person: person,
				apptColumns: apptColumns
			}, () => {
				this.props.navigate('/BuildingAccess/MyRecord/Appointment_' + (newApptCopy.APPT_IDX + 1));
			});
		} else {
			this.props.navigate('/BuildingAccess/MyRecord/' + this.convertTabToURL(tab));
		}
	}
	
	copyPerson() {
		var person = this.copyObject(this.state.person);
		// reference to safety training certificate must be copied explicitly
		if (this.state.person.SafetyTraining !== undefined) {
			person.SafetyTraining = this.state.person.SafetyTraining;
		}
		return person;
	}
	
	onChange(accessor, value) {
		var newState = {
			person: this.copyPerson(),
		};
		this.setByAccessor(newState.person, accessor, value);
		// if this is a type or PI change
		if (this.rgxTestAccessor(rgxTypeId, accessor) || this.rgxTestAccessor(rgxPIRoleId, accessor)) {
			// regenerate appt columns as duplicate status may have changed
			newState.apptColumns = this.generateApptColumns(newState.person, this.state.pendingRequests);
		}
		// if this accessor represents an EditTable
		if (this.rgxTestAccessor(rgxKeys, accessor) || this.rgxTestAccessor(rgxAccess, accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.mergeState(newState);
	}
	
	rgxTestAccessor(rgx, accessor) {
		if (Array.isArray(accessor)) {
			for (var i = 0; i < accessor.length; i++) {
				if (rgx.test(accessor[i])) return true;
			}
			return false;
		} else {
			return rgx.test(accessor);
		}
	}
	
	generatePersonColumns(person)
	{
		var columnsWithDept = this.shallowCopyColumns(person.PeopleView ? personColumns : requestColumns);
		for (var i = 0; i < columnsWithDept.length; i++) {
			if (!person.IsPI && (columnsWithDept[i].accessor === 'PeopleView.PI_EMER_PHONE1' || columnsWithDept[i].accessor === 'PeopleView.PI_EMER_PHONE2')) {
				// not a PI, don't need these columns
				columnsWithDept.splice(i--, 1);
			} else if (columnsWithDept[i].accessor === 'SafetyTraining' && columnsWithDept[i].type === 'file' && person.SafetyTraining) {
				// user already uploaded a safety certificate
				columnsWithDept.splice(i--, 1);
			} else if (columnsWithDept[i].accessor === 'SafetyTraining' && columnsWithDept[i].editable === false && !person.SafetyTraining) {
				// user has not uploaded a safety certificate yet, so remove static text
				columnsWithDept.splice(i--, 1);
			}
		}
		
		return columnsWithDept;
	}
	
	generateApptColumns(person, pendingRequests) {
		// generate an array of columns for the appointments
		var apptColumns = [];

		// iterate backwards so that only newest duplicates are flagged
		for (var i = person.appointments.length - 1; i >= 0; i--) {
			// if this is a new appointment
			if (person.appointments[i].newAppointmentFlag) {
				// copy new appointment columns
				var newApptColsCopy = this.copyColumns(newApptColumns);
				// check if this is a duplicate
				var isDuplicate = this.isDuplicateAppointment(person, pendingRequests, i);
				// if this is not a duplicate
				if (isDuplicate === duplicateAppointment.unique) {
					// remove override checkbox from column array
					newApptColsCopy.splice(newApptColsCopy.length - 1, 1);
				} else if (isDuplicate === duplicateAppointment.request) {
					// modify label with info about duplicated request
					newApptColsCopy[newApptColsCopy.length - 1].label = '(' + person.appointments[i].TYPE_NAME + 
						' request exists for PI ' + person.appointments[i].PI_NAME + ')';
				} else {
					// modify label with info about duplicated appointment
					newApptColsCopy[newApptColsCopy.length - 1].label = '(' + person.appointments[i].TYPE_NAME + 
						' appointment exists with PI ' + person.appointments[i].PI_NAME + ')';
				}
				
				apptColumns.unshift(newApptColsCopy);
			} else {
				apptColumns.unshift(this.copyColumns(existingApptColumns));
			}
		}

		return apptColumns;
	}
		
	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}
	
	validateAllTabs() {
		// validate person against person columns
		var errmsg = this.validate(this.state.personColumns, this.state.person);
		if (!this.isEmpty(errmsg)) errmsg = 'General Info: ' + errmsg;
		
		// if this is a brand new person and there are no appointment requests
		if (this.state.person.NewRequest && this.state.person.NewRequest.REQ_ID === 0 &&
			this.state.pendingRequests.length === 0 && this.state.person.appointments.length === 0) {
			if (this.isEmpty(errmsg)) {
				errmsg = '';
			} else {
				errmsg += '; ';
			}
			errmsg += 'Appointments: there must be at least one appointment request. Add one using the [+] tab header.';
		}
		
		// for each appointment
		for (var i = 0; i < this.state.person.appointments.length; i++) {
			var apptmsg = this.validate(this.state.apptColumns[i], this.state.person.appointments[i]);
			if (!this.isEmpty(apptmsg)) {
				if (!this.isEmpty(errmsg)) {
					errmsg += '; Appointment ' + (i + 1) + ': ' + apptmsg;
				} else {
					errmsg = 'Appointment ' + (i + 1) + ': ' + apptmsg;
				}
			}
		}
		
		return errmsg;
	}

	onSubmit(event) {
		var self = this;
		var i;
		
		var errmsg = this.validateAllTabs();
		if (!this.isEmpty(errmsg)) {
			this.showAlert('Validation Error', errmsg);
		} else {
			var person = this.copyPerson();
			
			// IMPORTANT: the "change flag" determines where the req_id in the role request points to!
			// if true, it is a person_id from the people table; if false, it is a req_id from the new_request table.
			// it has nothing to do with whether any appointment is new or changing.
			var blnChangeFlag = person.PeopleView ? true : false;
			
			// if there are comments that might have html
			if (blnChangeFlag && !this.isEmpty(person.PeopleView.COMMENTS)) {
				// html encode so that server will not reject html
				person.PeopleView.COMMENTS = encode(person.PeopleView.COMMENTS);
			}
					
			// get the file info from the person
			var safety = person.SafetyTraining;

			// set to empty array so marshaling will work
			person.SafetyTraining = [];
			
			// convert dates
			if (blnChangeFlag && person.PeopleView.END_DATE) {
				person.PeopleView.END_DATE = this.dateTimeToMVC(this.getDate(person.PeopleView.END_DATE));
			} else if (!blnChangeFlag && person.NewRequest.END_APPT) {
				person.NewRequest.END_APPT = this.dateTimeToMVC(this.getDate(person.NewRequest.END_APPT));
			}
			
			// copy email address so it is saved in all places
			if (blnChangeFlag) {
				person.PeopleView.EMAIL = this.getByAccessor(person, 'Roles[0].WorkContacts[0].WORK_NO_EMAIL');
				this.setByAccessor(person, 'Roles[0].WorkContacts[0].WORK_EMAIL', person.PeopleView.EMAIL);
				for (i = 0; i < person.appointments.length; i++) {
					person.appointments[i].EMAIL = person.PeopleView.EMAIL;
				}
			}
			
			// compose name for confirmation screen
			var name = blnChangeFlag ? 
				(person.PeopleView.LNAME + ', ' + person.PeopleView.FNAME) :
				(person.NewRequest.LNAME + ', ' + person.NewRequest.FNAME);
			
			var existingAppts = [];
			var newAppts = [];
			var newApptOverrides = [];
			
			for (i = 0; i < person.appointments.length; i++) {
				var appointmentView = this.copyObject(person.appointments[i]);
				
				// get access requests and stores checkbox
				var access = appointmentView.Access;
				appointmentView.Access = null;
				var keys = appointmentView.Keys;
				appointmentView.Keys = null;
				var storesByCheckbox = appointmentView.STORES_ACCESS === true;
				
				// see if storeroom was also requested by location
				var storesByLocation = false;
				for (var a = 0; a < access.length; a++) {
					if (access[a].LOC_ACCESS_ID === 1) {
						storesByLocation = true;
						break;
					}
				}
				
				// if stores was requested via the checkbox and not location
				if (storesByCheckbox && !storesByLocation) {
					// add a new access request for storeroom
					access.push({
						id: this.getNewRowID(access),
						ROLE_ID: appointmentView.newAppointmentFlag ? null : appointmentView.ROLE_ID,
						LOC_ACCESS_ID: 1,
						LOC_ACCESS_NAME: this.getLocationName(1)
					});
				}
				
				var appointment = {
					AppointmentView: appointmentView,
					Access: access,
					Keys: keys,
					Stores: false,
					Bixby: appointmentView.BIXBY_ACCESS === true,
					Change: blnChangeFlag,
					NewPerson: this.props.user.personID === null
				};
				
				// convert dates
				appointment.AppointmentView.BEG_ROLE_DATE = this.dateTimeToMVC(this.getDate(appointment.AppointmentView.BEG_ROLE_DATE));
				appointment.AppointmentView.END_ROLE_DATE = this.dateTimeToMVC(this.getDate(appointment.AppointmentView.END_ROLE_DATE));
				
				if (appointment.AppointmentView.newAppointmentFlag) {
					if (this.isDuplicateAppointment(person, this.state.pendingRequests, i)) {
						newApptOverrides.push(appointment);
					} else {
						newAppts.push(appointment);
					}
				} else {
					existingAppts.push(appointment);
				}
			}
			
			// make list of pending request IDs we intend to keep
			var keepReqRoleIDs = [];
			for (i = 0; i < this.state.pendingRequests.length; i++) {
				keepReqRoleIDs.push(+this.state.pendingRequests[i].REQ_ROLE_ID);
			}
			
			// Create an object of formData
			const formData = new FormData();

			// add the token to the formData
			formData.append("__RequestVerificationToken", this.props.user.antiForgeryToken);
			
			// add the person to the formData
			var nvpairs = this.createHiddenFormData({ Person: person });
			for (i = 0; i < nvpairs.length; i++) formData.append(nvpairs[i].name, nvpairs[i].value);
			
			// add remaining req role IDs to form data
			nvpairs = this.createHiddenFormData({ appt_requests: keepReqRoleIDs });
			for (i = 0; i < nvpairs.length; i++) formData.append(nvpairs[i].name, nvpairs[i].value);
			
			// add existing appointments to form data
			nvpairs = this.createHiddenFormData({ existing_appts: existingAppts });
			for (i = 0; i < nvpairs.length; i++) formData.append(nvpairs[i].name, nvpairs[i].value);

			// add new appointments to form data
			nvpairs = this.createHiddenFormData({ new_appts: newAppts });
			for (i = 0; i < nvpairs.length; i++) formData.append(nvpairs[i].name, nvpairs[i].value);
			
			// add overriding new appointments to form data
			nvpairs = this.createHiddenFormData({ new_overrides: newApptOverrides });
			for (i = 0; i < nvpairs.length; i++) formData.append(nvpairs[i].name, nvpairs[i].value);	

			// if there is a safety certificate, add it
			if (safety && safety.name) formData.append("safety_cert", safety, safety.name);
			
			this.ajax({
				type: 'POST',
				url: this.getConfig().host + '/BuildingAccess/UpdateMyRecord',
				data: formData,
				contentType: false,
				processData: false,
				overlay: true,
			}).done(function (data) {
				if (data.Success) {
					self.showConfirmation(() => 
						<>Record updated for <a href='/BuildingAccess/MyRecord'>{name}</a></>
					);
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	composeGreeting() {
		if (this.state.person.NewRequest) {
			return 'Welcome to College of Chemistry ' + this.state.person.NewRequest.FNAME + '!';
		} else {
			return 'Welcome Back ' + this.state.person.PeopleView.FNAME + '!';
		}
	}

	shallowCopyColumns(columns) {
		var shallowCopy = [];
	
		for (var i = 0; i < columns.length; i++) {
			shallowCopy.push(this.mergeObject(columns[i], {}));
		}
		
		return shallowCopy;
	}

	getBuildingStateID(buildingID) {
		return 'BUILDING_' + buildingID;
	}
	
	getAppointmentIndex() {
		if ((this.state.activeTab || 'General_Info').startsWith('Appointment_')) {
			return this.getNumeric(this.state.activeTab.substring(12), 0) - 1;
		}
		return -1;
	}
	
	isDuplicateAppointment(person, pendingRequests, apptIdx) {
		var i;
		
		// get type and pi for appointment in question
		var typeId = this.getNumeric(person.appointments[apptIdx].TYPE_ID, -1);
		var piRoleId = this.getNumeric(person.appointments[apptIdx].PI_ROLE_ID, -1);
		
		// for each pending request
		for (i = 0; i < pendingRequests.length; i++) {
			// if this is the same role and pi
			if (pendingRequests[i].TYPE_ID === typeId &&
				pendingRequests[i].PI_ROLE === piRoleId) {
				// return duplicate request
				return duplicateAppointment.requested;
			}
		}
		
		// for each approved request older than this one, starting with the oldest
		for (i = 0; i < apptIdx; i++) {
			// if this is the same role and pi
			if (person.appointments[i].TYPE_ID === typeId &&
				person.appointments[i].PI_ROLE_ID === piRoleId) {
				// return duplicate requested or approved
				return person.appointments[i].newAppointmentFlag ?
					duplicateAppointment.requested : duplicateAppointment.approved;
			}
		}
		
		// nothing was found so this is a unique request
		return duplicateAppointment.unique;
	}

	getNewRowID(rows) {
		var maxId = -1;
		for (var i = 0; i < rows.length; i++) {
			if (rows[i].id > maxId) maxId = rows[i].id;
		}
		return maxId + 1;
	}

	getBuildingName(buildingID) {
		for (var i = 0; i < this.state.buildings.length; i++) {
			if (this.state.buildings[i].BUILDING_ID === buildingID) {
				return this.state.buildings[i].BUILDING_NAME;
			}
		}
		
		return null;
	}
	
	getLocationName(locAccessID) {
		for (var i = 0; i < this.state.locations.length; i++) {
			if (this.state.locations[i].LOC_ACCESS_ID === locAccessID) {
				return this.state.locations[i].LOC_ACCESS_NAME;
			}
		}
		
		return null;
	}
	
	getRoomName(buildingID, roomID) {
		var bldgStateID = this.getBuildingStateID(buildingID);
		
		var rooms = this.state.rooms[bldgStateID];
		
		for (var i = 0; i < rooms.length; i++) {
			if (rooms[i].ROOM_ID === roomID) return rooms[i].ROOM_NAME;
		}
		
		return null;
	}

	addAccessRequest(event, apptIdx) {	
		if (apptIdx >= 0) {
			// add to existing appointment
			var appointments = this.copyObject(this.state.person.appointments);
			appointments[apptIdx].Access.push({
				id: this.getNewRowID(appointments[apptIdx].Access),
				ROLE_ID: appointments[apptIdx].ROLE_ID,
				LOC_ACCESS_ID: +appointments[apptIdx].selectedLocation,
				LOC_ACCESS_NAME: this.getLocationName(+appointments[apptIdx].selectedLocation)
			});
			this.mergeState({
				person: {
					appointments: appointments,
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}

	addKeyRequest(event, apptIdx) {
		if (apptIdx >= 0) {
			// add key request to existing appointment
			var appointments = this.copyObject(this.state.person.appointments);
			appointments[apptIdx].Keys.push({
				id: this.getNewRowID(appointments[apptIdx].Keys),
				ROLE_ID: appointments[apptIdx].ROLE_ID,
				BUILDING_ID: +appointments[apptIdx].selectedBuilding,
				BUILDING_NAME: this.getBuildingName(+appointments[apptIdx].selectedBuilding),
				ROOM_ID: +appointments[apptIdx].selectedRoom,
				ROOM_NAME: this.getRoomName(+appointments[apptIdx].selectedBuilding, +appointments[apptIdx].selectedRoom)
			});
			this.mergeState({
				person: {
					appointments: appointments,
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}

	deleteAccessRequest(props) {
		var i;
		
		// get appointment index
		var apptIdx = this.getAppointmentIndex();
		
		if (apptIdx >= 0) {
			// update existing appointment
			var appointments = this.copyObject(this.state.person.appointments);
			
			// for each location
			for (i = 0; i < appointments[apptIdx].Access.length; i++) {
				// if the id matches
				if (appointments[apptIdx].Access[i].id === props.value) {
					// remove from access array
					appointments[apptIdx].Access.splice(i, 1);
					break;
				}
			}
			
			this.mergeState({
				person: {
					appointments: appointments,
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}

	deleteKeyRequest(props) {		
		var i;
		
		// get appointment index
		var apptIdx = this.getAppointmentIndex();
		
		if (apptIdx >= 0) {
			// update existing appointment
			var appointments = this.copyObject(this.state.person.appointments);
			
			// for each key
			for (i = 0; i < appointments[apptIdx].Keys.length; i++) {
				// if the id matches
				if (appointments[apptIdx].Keys[i].id === props.value) {
					// remove from keys array
					appointments[apptIdx].Keys.splice(i, 1);
					break;
				}
			}
			
			this.mergeState({
				person: {
					appointments: appointments,
				},
				renderKey: this.state.renderKey + 1
			});
		}
	}

	deleteRequest(reqRoleId) {
		var self = this;
		
		this.showOKCancel('Confirm Delete Request', 'Are you sure you want to delete this request?', (okButtonPressed) => {
			if (okButtonPressed) {
				// assemble new array of pending requests
				var pendingRequests = [];
				for (var i = 0; i < self.state.pendingRequests.length; i++) {
					if (self.state.pendingRequests[i].REQ_ROLE_ID !== reqRoleId) {
						pendingRequests.push(pendingRequests[i]);
					}
				}
				
				// merge into state
				self.mergeState({
					pendingRequests: pendingRequests
				});
			}
		});			
	}
	
	onCancelRequest(event) {
		var self = this;
		
		// get index of current appointment request
		var apptIdx = this.getAppointmentIndex();
		
		// copy array of appointments
		var appointments = this.copyObject(this.state.person.appointments);
		
		// remove the selected Appointment
		appointments.splice(apptIdx, 1);
		
		// update the state
		this.mergeState({
			person: {
				appointments: appointments
			}
		}, () => {
			// if we removed the last appointment
			if (apptIdx === appointments.length) {
				// if we removed the only appointment
				if (apptIdx === 0) {
					// navigate to pending requests
					self.props.navigate('/BuildingAccess/MyRecord/Pending_Requests');
				} else {
					// navigate to previous appt
					self.props.navigate('/BuildingAccess/MyRecord/Appointment_' + apptIdx);
				}
			}
		});
	}

	renderAccess(props) {
	  // get appointment index
	  var apptIdx = this.getAppointmentIndex();
	  if (apptIdx >= 0) {
		// get appointment
		var appointment = this.state.person.appointments[apptIdx];
		
		return (<Container>
		  <Row>
			<Col sm={9} style={{ marginTop: '-8px' }}>
			  <Form.Control as="select" value={appointment.selectedLocation}
				onChange={(event) => {
					// update the existing appointment
					var appointments = this.copyObject(this.state.person.appointments);
					appointments[apptIdx].selectedLocation = event.target.value;
					this.mergeState({
						person: {
							appointments : appointments
						}
					});
				}}>
				  {this.state.locations.map((option) => {
					  return (
						  <option key={option.LOC_ACCESS_ID} value={option.LOC_ACCESS_ID}>{option.LOC_ACCESS_NAME}</option>
					  );
				  })}
			  </Form.Control>
			</Col>
			<Col sm={3} style={{ marginTop: '-8px' }}>
			  <Button variant='warning' onClick={(event) => { this.addAccessRequest(event, apptIdx) }}>Add</Button>
			</Col>
		  </Row>
		  <Row>
		    <Col sm={12} style={{ marginTop: '8px' }}>
		      <ChemTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_MyAppointments_Access' columns={accessColumns} data={props.value} />
			</Col>
		  </Row>
		</Container>);
	  }
	}
	
	renderKeys(props) {
	  // get appointment index
	  var apptIdx = this.getAppointmentIndex();
	  if (apptIdx >= 0) {
		// get appointment
		var appointment = this.state.person.appointments[apptIdx];
		
		var rooms;
		
		// if a building has been selected
		if (appointment.selectedBuilding) {
			// get building state ID
			var bldgStateID = this.getBuildingStateID(appointment.selectedBuilding);
		
			// get list of rooms for this building
			rooms = this.state.rooms[bldgStateID];
		} else {
			// no building, no rooms
			rooms = [];
		}
		
		return (<Container>
		  <Row>
			<Col sm={5} style={{ marginTop: '-8px' }}>
			  <Form.Control as="select" value={appointment.selectedBuilding}
				onChange={(event) => {
					// get building state ID
					var bldgStateID = this.getBuildingStateID(event.target.value);
				
					// get list of rooms for this building
					rooms = this.state.rooms[bldgStateID];
					
					// update existing appointment - select first room by default
					var appointments = this.copyObject(this.state.person.appointments);
					appointments[apptIdx].selectedBuilding = event.target.value;
					appointments[apptIdx].selectedRoom = rooms[0].ROOM_ID;
					this.mergeState({
						person: {
							appointments : appointments
						}
					});
				}}>
				  {this.state.buildings.map((option) => {
					  return (
						  <option key={option.BUILDING_ID} value={option.BUILDING_ID}>{option.BUILDING_NAME}</option>
					  );										
				  })}
			  </Form.Control>
			</Col>
			<Col sm={4} style={{ marginTop: '-8px' }}>
			  <Form.Control as="select" value={appointment.selectedRoom}
				onChange={(event) => {
					// update existing appointment
					var appointments = this.copyObject(this.state.person.appointments);
					appointments[apptIdx].selectedRoom = event.target.value;
					this.mergeState({
						person: {
							appointments : appointments
						}
					});
				}}>
				  {rooms.map((option) => {
					  return (
						  <option key={option.ROOM_ID} value={option.ROOM_ID}>{option.ROOM_NAME}</option>
					  );										
				  })}
			  </Form.Control>
			</Col>
			<Col sm={3} style={{ marginTop: '-8px' }}>
			  <Button variant='warning' onClick={(event) => { this.addKeyRequest(event, apptIdx) }}>Add</Button>
			</Col>
		  </Row>
		  <Row>
		    <Col sm={12} style={{ marginTop: '8px' }}>
		      <ChemTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_MyAppointments_Keys' columns={keyColumns} data={props.value} />
			</Col>
		  </Row>
		</Container>);
	  }
	}

	renderBixbyAccess(props) {
		if (props.editor.props.data.EXISTING_BIXBY_ACCESS) {
			return <>You have Bixby access<br /></>;
		} else {
			return props.editor.renderFromCellDefinition();
		}
	}
	
	renderSpeedtype(props) {
		if (this.isEmpty(props.editor.props.data.PI_ROLE_ID)) {
			return (<span style={{ fontStyle: 'italic' }}>(Select PI to view speedtypes)</span>);
		} else {
			return props.editor.renderFromCellDefinition();
		}
	}
	
	renderStoresAccess(props) {
		if (props.editor.props.data.EXISTING_STORES_ACCESS) {
			return <>You have Chemistry Stores access<br /></>;
		} else {
			return props.editor.renderFromCellDefinition();
		}
	}
	
	renderWorkTitle(props) {
		if (props.editor.props.data.TYPE_ID && props.editor.props.data.TYPE_ID > 8 && props.editor.props.data.TYPE_ID < 25) {
			return props.editor.doNotRender();
		} else {
			return props.editor.renderFromCellDefinition();
		}
	}

	renderSafetyTrainingCertificate(props) {
		if (this.state.person.SafetyTraining && this.state.person.SafetyTraining.name) {
			// user has selected a certificate but not uploaded it
			return (<Row>
				<Col sm={12}>{this.state.person.SafetyTraining.name}</Col>
			</Row>);
		} else {
			// user has already uploaded a certificate and can view it
			return (<Row>
				<Col sm={8}>{this.state.person.SafetyTraining}</Col>
				<Col sm={4}>
					<form action={this.getConfig().host + '/BuildingAccess/DownloadSafetyCertificate'} method="POST">
						<input type="hidden" name="__RequestVerificationToken" value={this.props.user.antiForgeryToken} />
						<input type="hidden" name="caluid" value={this.props.user.uid} />
						<input type="submit" value="View" />
					</form>
				</Col>
			</Row>);
		}
	}
	
	prefixAccessor(prefix, accessor) {
		var prefixedAccessor;
		if (Array.isArray(accessor)) {
			prefixedAccessor = [];
			for (var i = 0; i < accessor.length; i++) {
				prefixedAccessor.push(prefix + accessor[i]);
			}
		} else {
			prefixedAccessor = prefix + accessor;
		}
		
		return prefixedAccessor;
	}

	render() {
		var self = this;
		
		// if the current tab contains a new appointment request we need to show the cancel button below the tabs
		var isNewAppt = false;
		var apptIdx = this.getAppointmentIndex();
		if (apptIdx >= 0 && this.state.person && Array.isArray(this.state.person.appointments) &&
			apptIdx < this.state.person.appointments.length &&
			this.state.person.appointments[apptIdx].newAppointmentFlag) {
			isNewAppt = true;
		}
		return (<>
			<Container fluid>
			  <Row>
				<Col xs={12} sm={12} md={12} lg={11} xl={10} style={{ paddingTop: '20px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.composeGreeting()}</span>
				  <ul>
					<li>Complete this form to update your record. Changes to General Info do not require approval.</li>
				    <li>To change your Appointment Type, PI, Supervisor, Unit, or Payroll Title:</li>
					<ol>
					    <li>End current appointment by entering an Appointment End Date</li>
						<li>Create a new appointment by clicking on the [+] tab</li>
						<li>New appointment requests will need to be approved before being taken into effect</li>
					</ol>
					<li>Keys and electronic access will be granted by your PI, Supervisor, or Delegate upon approval</li>
					<li>Required Field <span style={{ color: 'red' }}>*</span></li>
				  </ul>
				  <Tabs activeTab={this.convertURLToTab(this.state.activeTab)} canClickTabItem={(tab) => this.canClickTabItem(tab)} 
					onClickTabItem={(tab) => this.onClickTabItem(tab)}>
					<div label='General Info'>
					  <ChemEdit parent={this} columns={this.state.personColumns} data={this.state.person} user={this.props.user}
					    renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChange(accessor, value)} />
					</div>
					<div label='Pending Requests'>
					  {this.state.pendingRequests && this.state.pendingRequests.length > 0 ?
						<ChemTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_MyRecord_PendingRequests' 
						  columns={pendingRequestColumns} data={this.state.pendingRequests} />:
						<>No pending approval requests. To create an appointment request, press the [+] tab header.</>
					  }
					</div>
					{this.state.person.appointments.map((appointment, apptIdx) => {
					  var label = 'Appointment ' + (apptIdx + 1);
					  return (
						<div key={apptIdx} label={label}>
						  <ChemEdit parent={self} renderKey={self.state.renderKey} columns={this.state.apptColumns[apptIdx]}
							data={appointment} user={self.props.user} onChange={(accessor, value) =>
								self.onChange(self.prefixAccessor('appointments[' + apptIdx + '].', accessor), value)} />
						</div>
					  );
					})}
					<div label='+'>
					  <span>Navigating to this tab should create a new appointment.</span>
					</div>
				  </Tabs>
				  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					<Col xs={12}>
					  <Button style={{ marginLeft: '10px' }} id="update" variant="warning" type="button" 
					    onClick={(event) => this.onSubmit(event)}
						className="float-end">Submit All Changes</Button>
					  {isNewAppt && <Button id="cancelrequest" variant="warning" type="button" className="float-end"
						onClick={(event) => this.onCancelRequest(event)}>Cancel This Appointment Request</Button>
					  }
					</Col>
				  </Form.Group>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const personColumns = [
	{ Header: 'Last Name', accessor: 'PeopleView.LNAME', autocomplete: 'family-name', required: true },
	{ Header: 'First Name', accessor: 'PeopleView.FNAME', autocomplete: 'given-name', required: true },
	{ Header: 'Middle Name', accessor: 'PeopleView.MNAME', autocomplete: 'additional-name' },
	{ Header: 'Preferred Name', accessor: 'PeopleView.PREFERRED_NAME', autocomplete: 'nickname' },
	{ Header: 'Primary Department', accessor: 'PeopleView.DEPT_ID', type: 'select', required: true,
		options: { value: 'DEPARTMENT_ID', label: 'DEPT_NAME', entity: 'DEPARTMENT', order: [ 'DEPT_NAME' ] } },
	{ Header: 'Secondary Department', accessor: 'PeopleView.DEPT2_ID', type: 'select',
		options: { value: 'DEPARTMENT_ID', label: 'DEPT_NAME', entity: 'DEPARTMENT', order: [ 'DEPT_NAME' ] } },
	{ Header: 'Non-Career Appointment End Date', accessor: 'PeopleView.END_DATE', type: 'date', autocomplete: 'appointment-end-date' },
	{ Header: 'Campus Email', accessor: 'Roles[0].WorkContacts[0].WORK_NO_EMAIL', autocomplete: 'email', required: true },
	{ Header: 'Secondary Email', accessor: 'Addresses[0].LOCAL_EMAIL', autocomplete: 'email' },
	{ Header: 'Cell Phone', accessor: 'PeopleView.EMER_CELL', autocomplete: 'tel-national' },
	{ Header: 'Home Phone', accessor: 'Addresses[0].LOCAL_PHONE1', autocomplete: 'tel-national' },
	{ Header: 'Home Address 1', accessor: 'Addresses[0].LOCAL_STREET1', autocomplete: 'address-line1', required: true },
	{ Header: 'Home Address 2', accessor: 'Addresses[0].LOCAL_STREET2', autocomplete: 'address-line2' },
	{ Header: 'City', accessor: 'Addresses[0].LOCAL_CITY', autocomplete: 'address-level2', required: true },
	{ Header: 'Zip', accessor: 'Addresses[0].LOCAL_ZIP', autocomplete: 'postal-code', required: true },
	{ Header: 'Emergency Contact Name', accessor: 'PeopleView.EMERGENCY_CONTACT', required: true },
	{ Header: 'Emergency Contact Phone', accessor: 'PeopleView.EMERGENCY_CONTACT_PH', autocomplete: 'tel-national', required: true },
	{ Header: 'PI Lab Emergency Phone 1', accessor: 'PeopleView.PI_EMER_PHONE1' },
	{ Header: 'PI Lab Emergency Phone 2', accessor: 'PeopleView.PI_EMER_PHONE2' },
	{ Header: 'Cal1 Card ID', accessor: 'Cards[0].CARD_ID', required: true },
	{ Header: 'Cal1 Card Proximity Number<br /><span style="font-size: 12px; font-style: italic">(Required for after hours building access)</span>', 
		accessor: 'Cards[0].PROX_NUMBER', subscript: '<span style="font-size: 12px; font-style: italic">Enter first series of 5-6 digits on back of Cal1 Card bottom right corner</span>' },
	{ Header: 'Safety Training Certificate Upload', accessor: 'SafetyTraining', type: 'file', accept: 'application/pdf',
        subscript: '<br /><span style="font-size: 12px; font-style: italic">File Accepted: .pdf</span>' },
	{ Header: 'Safety Training Certificate Upload', accessor: 'SafetyTraining', editable: false,
		Cell: props => props.parent.renderSafetyTrainingCertificate(props) },
	{ Header: 'Record Create Date', accessor: 'PeopleView.CREATE_BY', editable: false },
	{ Header: 'Last Modified Date', accessor: 'PeopleView.MODIF_BY', editable: false }
];

const requestColumns = [
	{ Header: 'Last Name', accessor: 'NewRequest.LNAME', required: true },
	{ Header: 'First Name', accessor: 'NewRequest.FNAME', required: true },
	{ Header: 'Middle Name', accessor: 'NewRequest.MNAME' },
	{ Header: 'Preferred Name', accessor: 'NewRequest.PREF_NAME' },
	{ Header: 'Department', accessor: 'NewRequest.DEPT_ID', type: 'select', required: true,
		options: { value: 'DEPARTMENT_ID', label: 'DEPT_NAME', entity: 'DEPARTMENT', order: [ 'DEPT_NAME' ] } },
	{ Header: 'Non-Career Appointment End Date', accessor: 'NewRequest.END_APPT', type: 'date' },
	{ Header: 'Campus Email', accessor: 'NewRequest.CAMPUS_EMAIL', required: true },
	{ Header: 'Secondary Email', accessor: 'NewRequest.OTHER_EMAIL' },
	{ Header: 'Home Address 1', accessor: 'NewRequest.H_STREET1', maxlength: 60, required: true },
	{ Header: 'Home Address 2', accessor: 'NewRequest.H_STREET2', maxlength: 60 },
	{ Header: 'City', accessor: 'NewRequest.H_CITY', required: true },
	{ Header: 'Zip', accessor: 'NewRequest.H_ZIP', required: true },
	{ Header: 'Home Phone', accessor: 'NewRequest.H_PHONE' },
	{ Header: 'Cell Phone', accessor: 'NewRequest.CELL_PHONE' },
	{ Header: 'Emergency Contact Name', accessor: 'NewRequest.EMERGENCY_PERSON', required: true },
	{ Header: 'Emergency Contact Phone', accessor: 'NewRequest.EMERGENCY_CONTACT', required: true },
	{ Header: 'Cal1 Card ID', accessor: 'NewRequest.CARD_ID', required: true,
		subscript: '<span style="font-size: 12px; font-style: italic">Enter Employee ID if you do not have a Cal1 Card</span>'	},
	{ Header: 'Proximity Number<br /><span style="font-size: 12px; font-style: italic">(Required for after hours building access)</span>', 
		accessor: 'NewRequest.PROX_NUM', subscript: '<span style="font-size: 12px; font-style: italic">Enter first series of 5-6 digits on back of Cal1 Card bottom right corner</span>' },
	{ Header: 'Lab Emergency Phone 1<br /><span style="font-size: 12px; font-style: italic">(For PI Only)</span>', accessor: 'NewRequest.EMER_PHONE1' },
	{ Header: 'Lab Emergency Phone 2<br /><span style="font-size: 12px; font-style: italic">(For PI Only)</span>', accessor: 'NewRequest.EMER_PHONE2' },
	{ Header: 'Safety Training Certificate Upload', accessor: 'SafetyTraining', type: 'file', accept: 'application/pdf',
        subscript: '<br /><span style="font-size: 12px; font-style: italic">File Accepted: .pdf</span>' },
	{ Header: 'Safety Training Certificate Upload', accessor: 'SafetyTraining', editable: false,
		Cell: props => props.parent.renderSafetyTrainingCertificate(props) },
	{ Header: 'Comments for Supervisor/Delegate/PI<br /><span style="font-size: 12px; font-style: italic">250 Characters Maximum</span>', accessor: 'NewRequest.COMMENTS', type: 'textarea' }
];

const existingApptColumns = [
	{ Header: 'Appointment ID', accessor: 'ROLE_ID', editable: false },
	{ Header: 'Appointment Type', accessor: 'TYPE_NAME', editable: false },
	{ Header: 'PI/Faculty Sponsor/Unit Manager', accessor: 'PI_NAME', editable: false },
	{ Header: 'Functional Supervisor', accessor: 'SUP_NAME', editable: false },
	{ Header: 'Unit', accessor: 'UNIT_NAME', editable: false },
	{ Header: 'Payroll Title', accessor: 'TITLE_NAME', editable: false },
	{ Header: 'Directory Work Title', accessor: 'WORK_TITLE_ID', type: 'select', Cell: props => props.parent.renderWorkTitle(props),
		options: { value: 'WORK_TITLE_ID', label: 'WORK_TITLE_NAME', entity: 'WORK_TITLE', order: 'WORK_TITLE_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Appointment Start Date',	accessor: 'BEG_ROLE_DATE', type: 'date' },
	{ Header: 'Appointment End Date', accessor: 'END_ROLE_DATE', type: 'date',
      subscript: '<span style="font-size: 12px; font-style: italic">(MM/DD/YY)<br /><u>NOTE</u>: Entering a date will request immediate end of appointment.</span>'	},
	{ Header: 'Default Speedtype', accessor: 'SPEEDTYPE', type: 'select', Cell: props => props.parent.renderSpeedtype(props),
		options: { value: 'SPEEDTYPE', label: 'SPEEDTYPE_INFO', entity: 'ROLE_SPEEDTYPES_VW', order: 'SPEEDTYPE_INFO',
			search: { Operator: 'or', Children: [
				{ Attribute: 'ROLE_ID', Operator: '=', LongAccessor: 'PI_ROLE_ID' },
				{ Attribute: 'ROLE_ID', Operator: '=', LongAccessor: 'ROLE_ID' }
			]}}},
	{ Header: 'Primary Phone', accessor: 'PHONE1' },
	{ Header: 'Secondary Phone', accessor: 'PHONE2' },
	{ Header: 'Campus Office Location', accessor: 'ROOM_ID', type: 'select',
		options: { value: 'ROOM_ID', label: 'LOCATION', entity: 'ROOMS_VW', order: 'LOCATION' }},
	{ Header: 'Campus Lab Room', accessor: 'LAB_LOCATION' },
	{ Header: 'Campus Lab Building', accessor: 'LAB_BUILDING', type: 'select',
		options: { value: 'BUILDING_ID', label: 'BUILDING_NAME', entity: 'BUILDINGS_VW', order: 'BUILDING_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'CHEMISTRY_FLAG', Operator: '=', StringValue: 'Y' },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}
		}
	},
	{ Header: 'Alternate Room', accessor: 'ALT_LOCATION' },
	{ Header: 'Alternate Building', accessor: 'ALT_BUILDING', type: 'select',
		options: { value: 'BUILDING_ID', label: 'BUILDING_NAME', entity: 'BUILDINGS_VW', order: 'BUILDING_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Off Campus Location', accessor: 'OUTSIDE_LOCATION' },
	{ Header: 'Keys', accessor: 'Keys', Cell: props => props.parent.renderKeys(props) },
	{ Header: 'Access', accessor: 'Access', Cell: props => props.parent.renderAccess(props) },
	{ Header: 'Chemistry Storeroom Access', accessor: 'STORES_ACCESS', type: 'checkbox', label: 'YES', Cell: props => props.parent.renderStoresAccess(props),
	  subscript: '<span style="font-size: 12px; font-style: italic">Mandatory safety certification is required for access to the student workshop. After approval by your PI/Supervisor/Delegate, you will receive instructions for scheduling your safety certification training.</span>' },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', subscript: '<span style="font-size: 12px; font-style: italic">250 Characters Max</span>' },
	{ Header: 'Modified Date', accessor: 'MODIFIED', editable: false }
];

const newApptColumns = [
	{ Header: 'Appointment Type', accessor: 'TYPE_ID', labelAccessor: 'TYPE_NAME', type: 'select', required: true,
		options: { value: 'TYPE_ID', label: 'TYPE_NAME', entity: 'ROLE_TYPES', order: 'TYPE_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' },
				{ Attribute: 'TYPE_ID', Operator: 'not in', LongList: [4, 5, 6, 8, 28] }
			]}
		}
	},
	{ Header: 'PI/Faculty&nbsp;Sponsor/Unit&nbsp;Manager', accessor: 'PI_ROLE_ID', labelAccessor: 'PI_NAME', type: 'select', required: true,
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'PI_VW', order: 'PI_NAME' }},
	{ Header: 'Functional Supervisor', accessor: 'SUPERVISOR', type: 'select',
		options: { value: 'ROLE_ID', label: 'SUP_NAME', entity: 'SUPERVISORS_VW', order: 'SUP_NAME' }},
	{ Header: 'Payroll Title', accessor: 'PAYROLL_TITLE', type: 'select',
		options: { value: 'TITLE_ID', label: 'TITLE_NAME', entity: 'PAYROLL_TITLE', order: 'TITLE_NAME',
		search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Appointment Start Date', accessor: 'BEG_ROLE_DATE', type: 'date', required: true, subscript: '<span style="font-size: 12px; font-style: italic">(MM/DD/YY)</span>' },
	{ Header: 'Default Speedtype', accessor: 'SPEEDTYPE', type: 'select', Cell: props => props.parent.renderSpeedtype(props),
		options: { value: 'SPEEDTYPE', label: 'SPEEDTYPE_INFO', entity: 'ROLE_SPEEDTYPES_VW', order: 'SPEEDTYPE_INFO',
			search: { Attribute: 'ROLE_ID', Operator: '=', LongAccessor: 'PI_ROLE_ID' }}},
	{ Header: 'Primary Phone', accessor: 'PHONE1' },
	{ Header: 'Secondary Phone', accessor: 'PHONE2' },
	{ Header: 'Campus Office Location', accessor: 'ROOM_ID', type: 'select',
		options: { value: 'ROOM_ID', label: 'LOCATION', entity: 'ROOMS_VW', order: 'LOCATION' }},
	{ Header: 'Campus Lab Room', accessor: 'LAB_LOCATION' },
	{ Header: 'Campus Lab Building', accessor: 'LAB_BUILDING', type: 'select',
		options: { value: 'BUILDING_ID', label: 'BUILDING_NAME', entity: 'BUILDINGS_VW', order: 'BUILDING_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'CHEMISTRY_FLAG', Operator: '=', StringValue: 'Y' },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}
		}
	},
	{ Header: 'Alternate Room', accessor: 'ALT_LOCATION' },
	{ Header: 'Alternate Building', accessor: 'ALT_BUILDING', type: 'select',
		options: { value: 'BUILDING_ID', label: 'BUILDING_NAME', entity: 'BUILDINGS_VW', order: 'BUILDING_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Off Campus Location', accessor: 'OUTSIDE_LOCATION' },
	{ Header: 'Keys', accessor: 'Keys', Cell: props => props.parent.renderKeys(props) },
	{ Header: 'Access', accessor: 'Access', Cell: props => props.parent.renderAccess(props) },
	{ Header: 'Chemistry Storeroom Access', accessor: 'STORES_ACCESS', type: 'checkbox', label: 'YES', Cell: props => props.parent.renderStoresAccess(props),
	  subscript: '<span style="font-size: 12px; font-style: italic">Mandatory safety certification is required for access to the student workshop. After approval by your PI/Supervisor/Delegate, you will receive instructions for scheduling your safety certification training.</span>' },
	{ Header: 'Bixby After Hour Access', accessor: 'BIXBY_ACCESS', type: 'checkbox', label: 'YES', Cell: props => props.parent.renderBixbyAccess(props),
      subscript: '<span style="font-size: 12px; font-style: italic">Request for Bixby after hours access for undergraduates.<br/>Make sure <u>Shamaya Pellum</u> is selected as PI</span>' },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', subscript: '<span style="font-size: 12px; font-style: italic">250 Characters Max</span>' },
	{ Header: 'Confirm Duplicate Appointment Request', accessor: 'OVERRIDE', type: 'checkbox', label: '', required: true }
];

const keyColumns = [
	{ Header: '', accessor: 'id', Cell: props => <Trash style={{ cursor: 'pointer' }} onClick={() => props.parent.deleteKeyRequest(props)} />, width: 25 },
	{ Header: 'Building', accessor: 'BUILDING_NAME' },
	{ Header: 'Room', accessor: 'ROOM_NAME' },
	{ Header: 'BUILDING_ID', accessor: 'BUILDING_ID', show: false },
	{ Header: 'ROOM_ID', accessor: 'ROOM_ID', show: false },
	{ Header: 'ROLE_ID', accessor: 'ROLE_ID', show: false }
];

const accessColumns = [
	{ Header: '', accessor: 'id', Cell: props => <Trash style={{ cursor: 'pointer' }} onClick={() => props.parent.deleteAccessRequest(props)} />, width: 25 },
	{ Header: 'Location', accessor: 'LOC_ACCESS_NAME' },
	{ Header: 'LOC_ACCESS_ID', accessor: 'LOC_ACCESS_ID', show: false },
	{ Header: 'ROLE_ID', accessor: 'ROLE_ID', show: false }
];

const pendingRequestColumns = [
	{ Header: '', accessor: 'REQ_ROLE_ID', 
		Cell: props => { if (props.row.values.REQ_STATUS === 'R') return (<Trash style={{ cursor: 'pointer' }} onClick={() => props.parent.deleteRequest(props.value)} />); else return ''; }, width: 25 },
	{ Header: 'Appointment', accessor: 'TYPE_NAME' },
	{ Header: 'PI', accessor: 'PI_NAME' },
	{ Header: 'To Be Approved By', accessor: 'EMAIL_SENT' },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE' },
	{ Header: 'Appt. Date', accessor: 'APPT_DATE' },
	{ Header: 'Requested', accessor: 'REQUESTED' },
	{ Header: 'Status', accessor: 'REQ_STATUS' }
];

const newAppointment = {
	PERSON_ID: null,
	TYPE_ID: null,
	SPEEDTYPE: null,
	EXISTING_STORES_ACCESS: false,
	STORES_ACCESS: false,
	EXISTING_BIXBY_ACCESS: false,
	BIXBY_ACCESS: false,
	Keys: [],
	Access: [],
	selectedLocation: null,
	selectedBuilding: null,
	selectedRoom: null,
	newAppointmentFlag: true
};

const duplicateAppointment = {
	unique: 0,
	requested: 1,
	approved: 2
};

const rgxKeys = /^appointments\[([0-9]*)\].Keys$/;
const rgxAccess = /^appointments\[([0-9]*)\].Access$/;
const rgxTypeId = /^appointments\[([0-9]*)\].TYPE_ID$/;
const rgxPIRoleId = /^appointments\[([0-9]*)\].PI_ROLE_ID$/;

export default withMyRecordDefaultRoute(MyRecord);